import { defineComponent, reactive, h, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { NIcon, useMessage } from 'naive-ui'
import api from '@/api'
import {
  BookOutline as BookIcon,
  PersonOutline as PersonIcon,
  PersonCircleOutline as UserIcon,
  LogOutOutline as LogoutIcon
} from '@vicons/ionicons5'
import $FormDialogServer from '@/components/FormDialog'
import './index.scss'

export default defineComponent({
  name: 'TemplateEditor',
  setup(props, ctx) {
    const $router = useRouter()
    const message = useMessage()
    const addFormHandler = {
      fields: [
        {
          label: '大屏名称',
          key: 'title',
          type: 'input'
        },
        {
          label: '大屏宽度',
          key: 'width',
          type: 'number'
        },
        {
          label: '大屏高度',
          key: 'height',
          type: 'number'
        }
      ],
      modal: {
        title: '',
        width: '1920',
        height: '1080'
      },
      rules: {
        title: { required: true, message: '请输入大屏名称', trigger: 'blur' },
        width: { required: true, trigger: ['input', 'blur'] },
        height: { required: true, trigger: ['input', 'blur'] }
      }
    }
    const methods = {
      renderIcon(icon) {
        return () => h(NIcon, null, { default: () => h(icon) })
      },
      collapseChange() {
        state.collapsed = true
      },
      onExpand() {
        state.collapsed = false
      },
      goToPageById(name, id) {
        $router.push({
          name,
          params: { id }
        })
      },
      onAddBoxClick() {
        const { fields, modal, rules } = addFormHandler
        $FormDialogServer({
          title: '新建大屏',
          formModel: modal,
          formFields: fields,
          formRules: rules,
          onConfirm(formData) {
            const { width, height, ...rest } = formData
            const data = { ...rest, width: parseInt(width), height: parseInt(height) }
            methods.createNewDashboard(data)
          }
        })
      },
      async createNewDashboard(formData) {
        const params = {
          pageConfig: { ...formData },
          tpl: []
        }
        const resData = await api.saveDashboard(params)
        console.log('resData', resData)
        message.success('保存成功！')
        methods.goToPageById('PageEditor', resData.id)
      },
      async getList() {
        const { page, pageSize } = state
        const params = { pageSize, pageNum: page }
        const { total, list } = await api.getDashboardList(params)
        state.templateList = list
        state.total = total
      },
      onPageSizeChange() {
        state.page = 1
        methods.getList()
      },
      deleteTemplate(id) {
        window.$dialog.warning({
          title: '警告',
          content: '确定删除该大屏嘛？',
          positiveText: '确定',
          negativeText: '取消',
          onPositiveClick: async () => {
            await api.deleteDashboard({ id })
            message.success('删除成功')
            methods.getList()
          }
        })
      }
    }
    const renderIcon = (icon) => {
      return () => {
        return h(NIcon, null, {
          default: () => h(icon)
        })
      }
    }
    const state = reactive({
      collapsed: false,
      menuOptions: [
        {
          label: '模版案例',
          key: 'template-case',
          icon: methods.renderIcon(BookIcon)
        },
        {
          label: '我的模版',
          key: 'my-template',
          icon: methods.renderIcon(PersonIcon)
        }
      ],
      dropOptions: [
        {
          label: '个人信息',
          key: 'profile',
          icon: renderIcon(UserIcon)
        },
        {
          label: '退出登录',
          key: 'logout',
          icon: renderIcon(LogoutIcon)
        }
      ],
      activeKey: 'my-template',
      templateList: [],
      total: 0,
      pageSizes: [
        {
          label: '10 每页',
          value: 10
        },
        {
          label: '20 每页',
          value: 20
        },
        {
          label: '50 每页',
          value: 50
        },
        {
          label: '100 每页',
          value: 100
        }
      ],
      page: 1,
      pageSize: 10
    })
    onMounted(() => {
      methods.getList()
    })
    return () => (
      <n-space class="template-page page-container">
        <n-layout position="absolute">
          <n-layout-header class="template-page-header" bordered>
            <h2
              class="logo"
              {...{
                onClick: () => $router.push({ path: '/' })
              }}
            >
              <span class="title">Yafu</span>
            </h2>
            <div class="right-wrap">
              <n-dropdown options={state.dropOptions}>
                <n-avatar round>Y</n-avatar>
              </n-dropdown>
            </div>
          </n-layout-header>
          <n-layout has-sider class="template-page-main" position="absolute" style="top: 64px;">
            <n-layout-sider
              bordered
              show-trigger
              collapse-mode="width"
              collapsed-width={64}
              width={240}
              collapsed={state.collapsed}
              on-collapse={methods.collapseChange}
              on-expand={methods.onExpand}
            >
              <n-menu
                v-model={[state.activeKey, 'value']}
                collapsed-width={64}
                width={240}
                collapsed={state.collapsed}
                collapsed-icon-size={22}
                options={state.menuOptions}
              />
            </n-layout-sider>
            <n-layout class="template-page-content">
              <div class="page-header">
                <n-button
                  strong
                  type="primary"
                  {...{
                    onClick: () => {
                      methods.onAddBoxClick()
                    }
                  }}
                >
                  {{
                    default: () => '创建大屏',
                    icon: () => (
                      <n-icon>
                        <add />
                      </n-icon>
                    )
                  }}
                </n-button>
                <n-pagination
                  v-models={[
                    [state.page, 'page'],
                    [state.pageSize, 'page-size']
                  ]}
                  item-count={state.total}
                  show-size-picker
                  page-sizes={state.pageSizes}
                  {...{
                    onUpdatePage: (page) => methods.getList(),
                    onUpdatePageSize: (pageSize) => methods.onPageSizeChange()
                  }}
                />
              </div>
              <n-grid x-gap={24} y-gap={24} cols={5}>
                {state.templateList.map((item) => (
                  <n-grid-item>
                    <div class="template-case">
                      <div class="template-case-info">
                        {item.bgImg && <img class="template-case-img" src={item.bgImg} />}
                        <div class="template-case-menu">
                          <n-button
                            type="primary"
                            {...{
                              onClick: () => {
                                methods.goToPageById('PageEditor', item.id)
                              }
                            }}
                          >
                            编 辑
                          </n-button>
                        </div>
                      </div>
                      <div class="template-case-main">
                        <div class="template-case-main-title">{item.title}</div>
                        <div class="template-case-main-action">
                          <n-tooltip effect="dark" placement="top">
                            {{
                              trigger: () => (
                                <n-icon size="20">
                                  <EyeFilled
                                    {...{
                                      onClick: () => {
                                        methods.goToPageById('PagePreview', item.id)
                                      }
                                    }}
                                  />
                                </n-icon>
                              ),
                              default: () => '预览'
                            }}
                          </n-tooltip>
                          <n-tooltip effect="dark" placement="top">
                            {{
                              trigger: () => (
                                <n-icon size="20">
                                  <EditOutlined
                                    {...{
                                      onClick: () => {
                                        methods.goToPageById('PageEditor', item.id)
                                      }
                                    }}
                                  />
                                </n-icon>
                              ),
                              default: () => '编辑'
                            }}
                          </n-tooltip>
                          <n-tooltip effect="dark" placement="top">
                            {{
                              trigger: () => (
                                <n-icon size="20">
                                  <DeleteOutlined
                                    {...{
                                      onClick: () => {
                                        methods.deleteTemplate(item.id)
                                      }
                                    }}
                                  />
                                </n-icon>
                              ),
                              default: () => '删除'
                            }}
                          </n-tooltip>
                        </div>
                      </div>
                    </div>
                  </n-grid-item>
                ))}
              </n-grid>
            </n-layout>
          </n-layout>
        </n-layout>
      </n-space>
    )
  }
})
